import Vue from 'vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import jobPartiesMixin from './jobPartiesMixin'
import waitForRefreshApplicationMixin from './waitForRefreshApplicationMixin'
import { getJob } from '@/api/jobs/job/job'
import { Blockchain, BlockchainNames } from '@/constants/blockchain'
import { STAGE_IN_PROGRESS } from '@/constants/job/jobStages'
import Currency from '@/models-ts/Currency'
import Job from '@/models-ts/job/Job'
import { googleAnalyticsV2 } from '@/servicies-ts/analytics'
import { RootState } from '@/store'

export default Vue.extend({
  mixins: [jobPartiesMixin, waitForRefreshApplicationMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.jobChat.application.value,
      payToFreelancerLoading: (state: any) => state.jobDetails.payToFreelancerLoading,
    }),
    ...mapGetters({
      getIsPaying: 'jobDetails/getIsPaying',
    }),
    isPaying() {
      return this.getIsPaying(this.application?.job?.id)
    },
    hasPayJob() {
      return this.isEmployer && this.application.job?.stage === STAGE_IN_PROGRESS && !this.application.job?.isDone
    },
    hasAcceptJob() {
      return this.isEmployer && this.application.job?.stage === STAGE_IN_PROGRESS && this.application.job?.isDone
    },
  },
  methods: {
    ...mapMutations({
      setPayToFreelancerLoading: 'jobDetails/setPayToFreelancerLoading',
    }),
    ...mapActions({
      signPayToFreelancer: 'jobDetails/signPayToFreelancerV2',
    }),
    async payToTalent() {
      this.setPayToFreelancerLoading({ jobId: this.application?.job?.id })
      try {
        const job = Job.fromServer(await getJob(`${this.application.job.slug}-${this.application.job.id}`))
        this.signPayToFreelancer({
          job: job,
          successSign: async ({
            tx,
            walletName,
            currency,
            blockchain,
          }: {
            tx: string
            walletName: string
            currency: Currency
            blockchain: Blockchain
          }) => {
            this.sendSuccessAnalytics(tx, walletName, currency, blockchain)
            await this.waitRefreshApplication()
          },
        })
      } catch (err) {
        console.error(err)
        this.setPayToFreelancerLoading({ jobId: this.application?.job?.id, loading: false })
      }
    },
    sendSuccessAnalytics(tx: string, walletName: string, currency: Currency, blockchain: Blockchain) {
      googleAnalyticsV2.send({
        event: 'offer-job-payment',
        'event-content': tx,
        offer_id: this.application.offer.id,
        job_id: this.application.job.id,
        block_type: BlockchainNames[blockchain],
        currency: currency.name,
        sum: this.application.budgetUsdFormatted,
        wallet_integration_type: walletName,
      })
    },
  },
})
